/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * The strings used for the Administration capability.
 * @export
 */
export const ADMIN_CAPABILITY_STRINGS = {
  altTitle: `administration`,
  dialogBlurb: `gives you control over your subscription, users, and organization settings.`,
  dialogBullet1: `View your subscription status and product usage.`,
  dialogBullet2: `Access financial management functions.`,
  dialogBullet3: `Manage user role access.`,
  subtitle: `Manage your organization`,
  title: `Administration`,
};
